.footer-col {
    width: 100%;

    .title {
        margin-bottom: 16px;
        font-size: 20px;
        line-height: 27px;
    }

    ::slotted(lilu-p), ::slotted(lilu-link) {
        line-height: 37px;
    }

    ::slotted(.social-media) {
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: space-between;
        font-size: 25px;
        width: 80px;
        height: 37px;
    }
}